import { render, staticRenderFns } from "./FormLink.vue?vue&type=template&id=33ac62b0&scoped=true"
import script from "./FormLink.vue?vue&type=script&lang=js"
export * from "./FormLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac62b0",
  null
  
)

export default component.exports